<template>
  <v-card>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="onSubmit"
        lazy-validation
      >
        <v-container>
          <v-alert
            dense
            type="info"
          >
            Informações Pessoais
          </v-alert>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="desserts.nome"
                :counter="20"
                maxlength="20"
                :rules="fieldRules"
                label="Nome"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.sobrenome"
                :counter="50"
                maxlength="50"
                :rules="fieldRules"
                label="Sobrenome"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.dataNascimento"
                @input="dateMask"
                maxlength="10"
                label="Data Nascimento *"
                prepend-icon="mdi-calendar"
                placeholder="Data Nascimento"
                :rules="dateRules"
                required
              ></v-text-field>

              <!-- <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="desserts.dataNascimento"
                    label="Data Nascimento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="dateRules"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="desserts.dataNascimento"
                  no-title
                  scrollable
                  :format="'YYYY-MM-DD HH:mm'"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(desserts.dataNascimento)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu> -->

              <v-text-field
                v-model="desserts.cpf"
                :counter="14"
                maxlength="14"
                :rules="fieldRules"
                label="CPF *"
                @input="cpfMask"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>

              <v-select
                v-model="desserts.sexo"
                :items="genero"
                :rules="[v => !!v || 'Item is required']"
                label="Sexo"
                required
                item-text="name"
                item-value="value"
                persistent-hint
                return-object
                single-line
              ></v-select>

              <v-text-field
                v-model="desserts.celular"
                label="Celular"
                :counter="15"
                maxlength="15"
                @input="phoneMask"
              ></v-text-field>

              <v-text-field
                v-model="desserts.nomePai"
                label="Nome do Pai"
              ></v-text-field>

              <v-text-field
                v-model="desserts.nomeMae"
                label="Nome da Mãe"
              ></v-text-field>

              <v-text-field
                v-model="desserts.batismoNasAguas"
                @input="dateBatismoMask"
                maxlength="10"
                label="Data do Batismo nas Águas"
                prepend-icon="mdi-calendar"
                placeholder="Data do Batismo nas Águas"
              ></v-text-field>

              <!-- <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="desserts.batismoNasAguas"
                    label="Data do Batismo nas Águas"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="desserts.batismoNasAguas"
                  no-title
                  scrollable
                  :format="'YYYY-MM-DD HH:mm'"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(desserts.batismoNasAguas)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu> -->

              <v-text-field
                v-model="desserts.nacionalidade"
                label="Nacionalidade"
              ></v-text-field>

              <v-text-field
                v-model="desserts.estadoCivil"
                label="Estado Civil"
              ></v-text-field>

              <v-text-field
                v-model="desserts.rg"
                :counter="15"
                maxlength="15"
                label="RG"
                @input="rgMask"
              ></v-text-field>

              <v-text-field
                v-model="desserts.escolaridade"
                label="Escolaridade"
              ></v-text-field>
            </v-col>
          </v-row>
          <br>
          <v-alert
            dense
            type="info"
          >
            Informações de Endereço
          </v-alert>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="desserts.cep"
                :counter="9"
                maxlength="9"
                :rules="fieldRules"
                label="CEP"
                @input="cepMask"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.estado"
                :counter="2"
                :rules="fieldRules"
                label="Estado"
                maxlength="2"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.cidade"
                :counter="50"
                maxlength="50"
                :rules="fieldRules"
                label="Cidade"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.bairro"
                :counter="50"
                maxlength="50"
                :rules="fieldRules"
                label="Bairro"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.endereco"
                :counter="80"
                maxlength="80"
                :rules="fieldRules"
                label="Endereço"
                required
              ></v-text-field>

              <v-text-field
                v-model="desserts.complemento"
                label="Complemento"
              ></v-text-field>

              <v-text-field
                v-model="desserts.numero"
                :counter="10"
                maxlength="10"
                :rules="fieldRules"
                label="Número"
                required
              ></v-text-field>

            </v-col>
          </v-row>
          <br>
          <v-alert
            dense
            type="info"
          >
            Informações Religiosas
          </v-alert>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                  v-model="desserts.igrejaDoBatismo"
                  label="Igreja na qual se batizou?"
                ></v-text-field>

                <v-text-field
                  v-model="desserts.nomeTitularDaIgreja"
                  label="Nome Pastor Titular Da Igreja"
                ></v-text-field>

                <v-text-field
                v-model="desserts.frequentaIEQDesde"
                @input="dateFrequentaIeqMask"
                maxlength="10"
                label="Frequenta IEQ Desde?"
                prepend-icon="mdi-calendar"
                placeholder="Frequenta IEQ Desde?"
              ></v-text-field>

                <!-- <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :return-value.sync="desserts.frequentaIEQDesde"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="desserts.frequentaIEQDesde"
                      label="Frequenta IEQ Desde?"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="dateRules"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="desserts.frequentaIEQDesde"
                    no-title
                    scrollable
                    :format="'YYYY-MM-DD HH:mm'"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu3 = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu3.save(desserts.frequentaIEQDesde)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu> -->

                <v-text-field
                  v-model="desserts.quantasPessoasNaSuaCasa"
                  type="number"
                  label="Quantas Pessoas Na Sua Casa?"
                ></v-text-field>

                <v-text-field
                  v-model="desserts.origemReligiosa"
                  label="Origem Religiosa"
                ></v-text-field>
              <v-select
                v-model="desserts.batizadoNoEspirito"
                :items="defaultObj"
                item-text="name"
                item-value="value"
                label="Batizado no Espírito Santo?"
                persistent-hint
                return-object
                single-line
              ></v-select>

              <v-text-field
                v-model="desserts.pastorAtual"
                label="Nome do Pastor Atual"
              ></v-text-field>

              <v-select
                v-model="desserts.dizimista"
                :items="defaultObj"
                item-text="name"
                item-value="value"
                label="Dizimista?"
                persistent-hint
                return-object
                single-line
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="$emit('cancelar')"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="edit()"
              :disabled="!valid"
            >
              Salvar Edição
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import api from '../../../../plugins/api'
import Cookie from 'js-cookie'
import VueJwtDecode from 'vue-jwt-decode'

export default {
  data: () => ({
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    menu3: false,
    dialog: false,
    valid: false,
    enable: false,
    formHasErrors: false,
    fieldRules: [
      v => !!v || 'Campo obrigatório'
      // v => (v && v.length <= 100) || 'Name must be less than 10 characters'
    ],
    emailRules: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'O e-mail deve ser válido'
    ],
    dateRules: [
      v => !!v || 'Data é obrigatório'
    ],
    selectGenero: null,
    selectDizimista: null,
    selectBatismoEspirito: null,
    genero: [
      { value: 'F', name: 'Feminino' },
      { value: 'M', name: 'Masculino' }
    ],
    defaultObj: [
      { value: 'S', name: 'Sim' },
      { value: 'N', name: 'Não' }
    ],
    checkbox: false,
    editedItem: {
      nome: '',
      sobrenome: '',
      dataNascimento: '',
      email: '',
      telefone: '',
      celular: ''
    },
    desserts: {}

  }),
  // Esta props recebe do componente pai o objeto para editar um membro
  props: {
    desserts: {}
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    disable () {
      if (!this.fieldRules.v && !this.emailRules.v && !this.dateRules.v) {
        this.enable = false
      } else this.enable = true
    }
  },

  methods: {
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    phoneMask () {
      if (this.desserts.celular === null) {
        return
      }
      let r = this.desserts.celular.replace(/\D/g, '')
      r = r.replace(/^0/, '')
      if (r.length > 11) {
        r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3')
      } else if (r.length > 7) {
        r = r.replace(/^(\d\d)(\d{5})(\d{0,4}).*/, '($1) $2-$3')
      } else if (r.length > 2) {
        r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2')
      } else if (this.desserts.celular.trim() !== '') {
        r = r.replace(/^(\d*)/, '($1')
      }
      this.desserts.celular = r
    },
    cpfMask () {
      if (this.desserts.cpf === null) {
        return
      }
      let v = this.desserts.cpf.replace(/\D/g, '')
      v = v.replace(/^0/, '')
      v = v.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*/, '$1.$2.$3-$4')
      this.desserts.cpf = v
    },
    cepMask () {
      if (this.desserts.cep === null) {
        return
      }
      let c = this.desserts.cep.replace(/\D/g, '')
      c = c.replace(/^(\d{0,5})(\d{0,3}).*/, '$1-$2')
      this.desserts.cep = c
    },
    rgMask () {
      if (this.desserts.rg === null) {
        return
      }
      let rg = this.desserts.rg.replace(/[^\dX]/g, '')
      if (rg.length === 8 || rg.length === 9) {
        this.desserts.rg = rg.replace(/^(\d{1,2})(\d{3})(\d{3})([\dX])$/, '$1.$2.$3-$4')
      }
    },
    dateMask () {
      let v = this.desserts.dataNascimento.replace(/\D/g, '')
      v = v.replace(/^(\d{0,2})(\d{0,2})(\d{0,4}).*/, '$1/$2/$3')
      this.desserts.dataNascimento = v
    },
    dateBatismoMask () {
      let v = this.desserts.batismoNasAguas.replace(/\D/g, '')
      v = v.replace(/^(\d{0,2})(\d{0,2})(\d{0,4}).*/, '$1/$2/$3')
      this.desserts.batismoNasAguas = v
    },
    dateFrequentaIeqMask () {
      let v = this.desserts.frequentaIEQDesde.replace(/\D/g, '')
      v = v.replace(/^(\d{0,2})(\d{0,2})(\d{0,4}).*/, '$1/$2/$3')
      this.desserts.frequentaIEQDesde = v
    },

    edit () {
      this.formHasErrors = false

      Object.keys(this.desserts).forEach(f => {
        if (!this.desserts[f]) this.formHasErrors = true
        this.validate()
      })
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      if (this.desserts.dizimista.value) { this.desserts.dizimista = this.desserts.dizimista.value }
      if (this.desserts.batizadoNoEspirito.value) { this.desserts.batizadoNoEspirito = this.desserts.batizadoNoEspirito.value }
      if (this.desserts.sexo.value) { this.desserts.sexo = this.desserts.sexo.value }

      // if (this.desserts.batismoNasAguas !== null) { new Date(this.desserts.batismoNasAguas).toLocaleDateString() }
      if (this.desserts.dataDeInicio !== null) { new Date(this.desserts.dataDeInicio).toLocaleDateString() }
      // if (this.desserts.frequentaIEQDesde !== null) { new Date(this.desserts.frequentaIEQDesde).toLocaleDateString() }

      if (this.desserts.dataNascimento !== null) {
        let newDate = null
        var splitDate = this.desserts.dataNascimento.split('/')
        newDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
        this.desserts.dataNascimento = newDate
      }
      if (this.desserts.dataDeInicio !== null) {
        let newDate = null
        var splitDateInicio = this.desserts.dataDeInicio.split('/')
        newDate = splitDateInicio[2] + '-' + splitDateInicio[1] + '-' + splitDateInicio[0]
        this.desserts.dataDeInicio = newDate
      }

      if (this.desserts.batismoNasAguas !== null) {
        let newDatebatismoNasAguas = null
        var splitDatebatismoNasAguas = this.desserts.batismoNasAguas.split('/')
        newDatebatismoNasAguas = splitDatebatismoNasAguas[2] + '-' + splitDatebatismoNasAguas[1] + '-' + splitDatebatismoNasAguas[0]
        this.desserts.batismoNasAguas = newDatebatismoNasAguas
      }

      if (this.desserts.frequentaIEQDesde !== null) {
        let newDatefrequentaIEQDesde = null
        var splitDatefrequentaIEQDesde = this.desserts.frequentaIEQDesde.split('/')
        newDatefrequentaIEQDesde = splitDatefrequentaIEQDesde[2] + '-' + splitDatefrequentaIEQDesde[1] + '-' + splitDatefrequentaIEQDesde[0]
        this.desserts.frequentaIEQDesde = newDatefrequentaIEQDesde
      }
      if (this.desserts.cpf === null || this.desserts.cpf === undefined) {
        this.desserts.cpf = '000.000.000-00'
      }
      delete this.desserts.links
      this.desserts.IgrejaId = Number(decriptToken.id_church)
      // delete this.desserts.links
      api.put('/membros/' + Number(decriptToken.id_church), this.desserts).then((res) => {
        if (res.data === 1) {
          alert('Atualização Realizada!')
        } else if (res.data < 1) {
          alert('Não foi possível atualizar!\nFale com o suporte.')
        }
        this.closeAfterSave()
        // document.location.reload()
      }).catch((erro) => {
        if (erro !== null || erro !== undefined) {
          alert('Houve um erro para alterar o membro.\n Tente mais tarde!')
          this.closeAfterSave()
        }
      })
    },
    closeAfterSave () {
      this.$emit('closeAfterSave')
    }
  }
}
</script>

<style scoped>
.temp {
  width: 900px;
}
</style>
